import { Route } from '@angular/router';
import { AuthGuard } from 'shared/guards/auth.guard';
import { IsAuthenticatedAdminGuard } from 'shared/guards/is-authenticated-admin.guard';
import { IsNotAuthenticatedGuard } from 'shared/guards/is-not-authenticated.guard';
import { LayoutComponent } from 'shared/layout/layout.component';
import { SEOData } from 'shared/seo-data';
import { AccountComponent } from './account/account.component';
import { DashboardComponent } from './account/dashboard/dashboard.component';
import { AdminComponent } from './admin/admin.component';
import { AnnouncementsComponent } from './admin/announcements/announcements.component';
import { CreateOrUpdateAnnouncementComponent } from './admin/announcements/create-or-update-announcement/create-or-update-announcement.component';
import { BackupComponent } from './admin/backup/backup.component';
import { AdminDashboardComponent } from './admin/dashboard/dashboard.component';
import { ManageBlogComponent } from './admin/manage-blog/manage-blog.component';
import { ManagePostComponent } from './admin/manage-blog/manage-post/manage-post.component';
import { UserComponent } from './admin/users/user/user.component';
import { UsersComponent } from './admin/users/users.component';
import { AuthComponent } from './auth/auth.component';
import { ForgotPasswordPageComponent } from './auth/forgot-password-page/forgot-password-page.component';
import { RegisterPageComponent } from './auth/register-page/register.page.component';
import { RemoteLoginComponent } from './tools/remote-login/remote-login.component';
import { SubscriptionGuard } from 'shared/guards/subscription.guard';
import { ManagementGuard } from 'shared/guards/management.guard';

export const appRoutes: Route[] = [
    {
        path: '',
        component: LayoutComponent,
        data: { layout: 'empty'},
        canActivateChild: [IsNotAuthenticatedGuard],
        children: [
          { path: '', redirectTo: 'login', pathMatch: 'full' },
          {
            path: 'login',
            component: AuthComponent,
            data: { seo: SEOData.LOGIN }
          },
          {
            path: 'register',
            component: RegisterPageComponent,
            data: { seo: SEOData.REGISTER }
          },
          {
            path: 'forgot-password',
            component: ForgotPasswordPageComponent,
            data: { seo: SEOData.FORGOT_PASSWORD }
          },
          {
            path: 'forgot-password/:token/:emailAddress',
            component: ForgotPasswordPageComponent,
            data: { seo: SEOData.FORGOT_PASSWORD }
          },
          {
            path: 'remote-login/:oneTimeToken',
            component: RemoteLoginComponent,
          }
        ]
      },
      {
        path: '',
        component: LayoutComponent,
        data: { layout: 'modern'},
        children: [
          {
            path: 'account',
            component: AccountComponent,
            canActivate: [AuthGuard],
            canActivateChild: [AuthGuard],
            children: [
              { path: '', redirectTo: 'home', pathMatch: 'full' },
              { path: 'home', component: DashboardComponent, canActivate: [SubscriptionGuard], data: { seo: { title: "Dashboard"}} },
              { path: 'projects', canActivate: [SubscriptionGuard], loadChildren: () => import('./account/projects/projects.routes'), data: { seo: {title: "Projects" }} },
              { path: 'timesheets', canActivate: [SubscriptionGuard], loadChildren: () => import('./account/timesheets/timesheets.routes'), data: { seo: {title: "Timesheets" }} },
              { path: 'settings', loadChildren: () => import('./account/settings/settings.routes'), data: { seo: {title: "Settings" }} },
              { path: 'my-account', loadChildren: () => import('./account/my-account/my-account.routes'), data: { seo: {title: "My account" }} },
              { path: 'markouts', canActivate: [SubscriptionGuard], loadChildren: () => import('./account/markouts/markouts.routes'), data: { seo: {title: "Markouts" }} },
              { path: 'management', canActivate: [SubscriptionGuard, ManagementGuard], loadChildren: () => import('./account/management/management.routes'), data: { seo: {title: "Admin" }} },
              { path: 'garage', canActivate: [SubscriptionGuard], loadComponent: () => import('./account/garage/garage.component').then(m => m.GarageComponent), data: { seo: {title: "Garage" }} },
              { path: 'manager', canActivate: [SubscriptionGuard], loadComponent: () => import('./account/manager/manager.component').then(m => m.ManagerComponent), data: { seo: {title: "Manager" }} },
              { path: 'ledger', canActivate: [SubscriptionGuard], loadComponent: () => import('./account/ledger/ledger.component').then(m => m.LedgerComponent), data: { seo: {title: "Ledger" }} },
              { path: 'yard-ops', canActivate: [SubscriptionGuard], loadComponent: () => import('./account/yard-ops/yard-ops.component').then(m => m.YardOpsComponent), data: { seo: {title: "Yard Ops" }} }
            ]
          },
          {
            path: 'admin',
            component: AdminComponent,
            canActivate: [ IsAuthenticatedAdminGuard ],
            canActivateChild: [ IsAuthenticatedAdminGuard ],
            children: [
              { path: '', redirectTo: 'pulpit', pathMatch: 'full' },
              { path: 'pulpit', component: AdminDashboardComponent, data: { title: "Pulpit" } },
              { path: 'users', component: UsersComponent, data: { title: "Użytkownicy" } },
              { path: 'users/:id', component: UserComponent, data: { title: "Użytkownik" } },
              { path: 'announcements', component: AnnouncementsComponent, data: { title: "Ogłoszenia" } },
              { path: 'announcements/:id', component: CreateOrUpdateAnnouncementComponent, data: { title: "Ogłoszenie" } },
              { path: 'blog', component: ManageBlogComponent, data: { title: "Blog" } },
              { path: 'blog/post/add', component: ManagePostComponent, data: { title: "Post" } },
              { path: 'blog/post/edit/:id', component: ManagePostComponent, data: { title: "Post" } },
              { path: 'backup', component: BackupComponent, data: { title: "Backup" } },
        
            ]
          },
        ]
      },
      {
        path: '**',
        redirectTo: '/login',
        pathMatch: 'full'
      }
]